/**
 * Reducer for state.ui.workflowDetailsTable
 */
import _ from 'underscore';

import {BenchlingAction} from 'redux-stores/Action';

import {WorkflowDetailsTableActionType} from './WorkflowDetailsTableReduxActions';

export interface WorkflowDetailsTableState {
  isStageExpandedById: {[stageId: string]: boolean};
}

const INITIAL_STATE: WorkflowDetailsTableState = {
  isStageExpandedById: {},
};

export default function reduceWorkflowDetailsTable(
  state: WorkflowDetailsTableState = INITIAL_STATE,
  action: BenchlingAction
): WorkflowDetailsTableState {
  switch (action.type) {
    case WorkflowDetailsTableActionType.WORKFLOW_DETAILS_TABLE_EXPAND_STAGES: {
      const {stageIds} = action;
      return {
        ...state,
        isStageExpandedById: {
          ...state.isStageExpandedById,
          ..._.object(stageIds.map((stageId: string) => [stageId, true])),
        },
      };
    }
    case WorkflowDetailsTableActionType.WORKFLOW_DETAILS_TABLE_COLLAPSE_STAGES: {
      const {stageIds} = action;
      return {
        ...state,
        isStageExpandedById: {
          ...state.isStageExpandedById,
          ..._.object(stageIds.map((stageId: string) => [stageId, false])),
        },
      };
    }
    case WorkflowDetailsTableActionType.WORKFLOW_DETAILS_TABLE_TOGGLE_STAGE:
      return {
        ...state,
        isStageExpandedById: {
          ...state.isStageExpandedById,
          [action.stageId]: !state.isStageExpandedById[action.stageId],
        },
      };
    default:
      return state;
  }
}
